import Dashboard from './PhishingDashboard'
import Edit from './PhishingEdit'
import Main from './PhishingMain'
import New from './PhishingNew'
import Show from './PhishingShow'

export default {
  Dashboard,
  Edit,
  Main,
  New,
  Show,
}
